import CourseListPage from "@/views/courses/CourseListPage.vue"
import CoursePage from "@/views/courses/CoursePage.vue"
import SessionListPage from "@/views/sessions/SessionListPage.vue"
import StudentListPage from "@/views/students/StudentListPage.vue"
import StudentPage from "@/views/students/StudentPage.vue"
import AssistantListPage from "@/views/assistants/AssistantListPage.vue"
import PresenceListPage from "@/views/presences/PresenceListPage.vue"
import ExportPage from "@/views/export/ExportPage.vue"
import UserListPage from "@/views/users/UserListPage.vue"
import ProfilePage from "@/views/profile/ProfilePage.vue"
import DescriptionsPage from "@/views/descriptions/DescriptionsPage.vue"
import CreateStudentPage from "@/views/students/CreateStudentPage.vue"

import FluxPage from "@/views/flux/FluxPage.vue"

export const routes = [
  {
    path: "/",
    redirect: "/courses",
  },
  {
    path: "/flux",
    component: FluxPage,
  },
  {
    path: "/presences",
    component: PresenceListPage,
  },
  {
    path: "/session",
    component: SessionListPage,
  },
  {
    path: "/courses",
    component: CourseListPage,
  },
  {
    path: "/courses/:courseId",
    component: CoursePage,
    props: (route) => {
      const course_id = Number.parseInt(route.params.courseId, 10)
      if (Number.isNaN(course_id)) {
        return 0
      }
      return { course_id }
    },
  },
  {
    path: "/students",
    component: StudentListPage,
  },
  {
    path: "/assistants",
    component: AssistantListPage,
  },
  {
    path: "/students/create",
    component: CreateStudentPage,
  },
  {
    path: "/students/:studentId",
    component: StudentPage,
    props: (route) => {
      const student_id = Number.parseInt(route.params.studentId, 10)
      return {
        student_id: Number.isNaN(student_id) ? 0 : student_id,
        create_mode: route.query.create_mode === "true",
      }
    },
  },
  {
    path: "/export",
    component: ExportPage,
  },
  {
    path: "/users/",
    component: UserListPage,
  },
  {
    path: "/descriptions/",
    component: DescriptionsPage,
  },
  {
    path: "/my-profile/",
    component: ProfilePage,
  },
]
